/**
 * Returns a list with stopwords for the Czech passive voice assessment.
 * @returns {Array} The list with stopwords.
 */
export default [
	"protože",
	"když",
	"sbohem",
	"sotva",
	"kdo",
	"co",
	"kde",
	"odkud",
	"kdy",
	"odkdy",
	"ačkoli",
	"navzdory",
	"ačkoli",
	"když",
	"kde",
	"aby",
	"pořádku",
	"kdyby",
	"jak",
	"do",
	"že",
	"jako",
	"přesně",
	"jako",
	"než",
	"aby",
	"kdo",
	"kde",
	"kdo",
	"koho",
	"kde",
	"kolik",
	"odkud",
	"proč",
	"kolik",
	"nebo",
];
